var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"standardSide1"},[_c('el-image',{attrs:{"src":_vm.obj.cover_img,"preview-src-list":[_vm.obj.cover_img]}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }